module.exports = require('events').EventEmitter;



//////////////////
// WEBPACK FOOTER
// ./~/browserify-sign/~/readable-stream/lib/internal/streams/stream-browser.js
// module id = 317
// module chunks = 0